import {
  CREATE_CHECKUP_FAILURE,
  CREATE_CHECKUP_SUCCESS,
  FETCH_ALL_CHECKUPS,
  GET_ALL_CHECKUPS_FAILURE,
  GET_ALL_CHECKUPS_SUCCESS,
  GET_CHECKUP_TYPE_FAILURE,
  GET_CHECKUP_TYPE_SUCCESS,
  FETCH_CHECKUP_TYPES,
  CREATE_CHECKUP,
} from "../constant";
import { Auth, API } from "aws-amplify";

const createCheckupSuccess = (success, message) => {
  return {
    type: CREATE_CHECKUP_SUCCESS,
    payload: { success, message },
  };
};

const createcheckupFailure = (error) => {
  return {
    type: CREATE_CHECKUP_FAILURE,
    payload: { error },
  };
};
export const createcheckup = () => {
  return {
    type: CREATE_CHECKUP,
  };
};

export const createCheckup = (data) => {
  return async (dispatch) => {
    dispatch(createcheckup());
    API.post('AdminQueries', '/api/v1/createcheckup', {
      body: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        if (res.success) {
          dispatch(
            createCheckupSuccess(res.success, res.message.message)
          );
        }
      })
      .catch((err) => {
        dispatch(
          createcheckupFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const getAllCheckupsSuccess = (checkups) => {
  return {
    type: GET_ALL_CHECKUPS_SUCCESS,
    payload: {
      success: checkups.success,
      lastCheckups: checkups.message.rows ? checkups.message.rows : "",
      message: checkups.message.rows ? "" : checkups.message,
    },
  };
};

const getAllCheckupsFailure = (error) => {
  return {
    type: GET_ALL_CHECKUPS_FAILURE,
    payload: { error },
  };
};

export const fetchAllCheckups = () => {
  return {
    type: FETCH_ALL_CHECKUPS,
  };
};

export const getAllCheckups = (data) => {
  return async (dispatch) => {
    dispatch(fetchAllCheckups());
    API.get('UserQueries', "api/v1/getallcheckups", {
      queryStringParameters: {
        offset: data.offset,
        limit: data.limit,
        park_id: data.park_id,
      },
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getAllCheckupsSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getAllCheckupsFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const getCheckupTypeSuccess = (types) => {
  return {
    type: GET_CHECKUP_TYPE_SUCCESS,
    payload: {
      success: types.success,
      checkupTypes: types.message.rows,
    },
  };
};

const getCheckupTypeFailure = (error) => {
  return {
    type: GET_CHECKUP_TYPE_FAILURE,
    payload: { error },
  };
};

const fetchCheckupType = () => {
  return {
    type: FETCH_CHECKUP_TYPES,
  };
};

export const getCheckupType = () => {
  return async (dispatch) => {
    dispatch(fetchCheckupType());
    API.get('AdminQueries', '/api/v1/getcheckuptype', {
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getCheckupTypeSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getCheckupTypeFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};
